import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import { bindActionCreators, Dispatch } from "redux"
import { NotificationLevel } from "../notification"
import * as actionCreators from "../../action-creators"
import { LocalAuthority } from "../../model"
import { ReducerState, MappedActionsProps } from "../../reducer"
import Politique from "./politique"
import {
	updateMinGrossCashFlow,
	updateMaxDebtRefundPercentageOnCashFlow,
	updateMaxDeleveragingYears
} from "../../service/sfp/local-authorities-service-2"
import Spinner from "react-spinkit";


const Names = {
	maxDebtRefund: "max-debt-refund",
	maxDeleveragingYears: "max-deleveraging-years",
	minGrossCashFlow: "min-gross-cash-flow",
}

class Policy extends React.Component<InjectedProps, State> {
	constructor(props: Readonly<InjectedProps>) {
		super(props)
		this.state = {
			updatingMaxDebtRefund: false,
			updatingMaxDeleveragingYears: false,
			updatingMinGrossCashFlow: false,
			localshow:true,
			maxDebtRefund: null,
			maxDeleveragingYears: null,
			minGrossCashFlow: null
		}
	}

	componentDidMount() {
		this.props.actions.setPageTitle("Référentiel de gestion")
		const localAuthority = this.props.currentLocalAuthority
		
		if(localAuthority){
			this.setData(localAuthority)
		}	
	}

	componentDidUpdate(){
		const localAuthority = this.props.currentLocalAuthority
		if(localAuthority && this.state.localshow){
			this.setData(localAuthority)
			this.props.actions.allScenarios(localAuthority.id)
		}		
	}

	render() {
		const localAuthority = this.props.currentLocalAuthority

		const controls: ControlDefinition[] = [
			/** CAF brute minimum */
			{
				value: this.state.minGrossCashFlow,
				addon: <FontAwesomeIcon icon="euro-sign" />,
				className: this.getControlClassName(this.state.updatingMinGrossCashFlow),
				defaultValue: this.state.minGrossCashFlow,
				disabled: this.isControlLoading(this.state.updatingMinGrossCashFlow),
				label: "CAF brute minimum (en €)",
				name: Names.minGrossCashFlow
			},
			/** Nombre d’années de désendettement maximum */
			{
				value: this.state.maxDeleveragingYears,
				addon: "ans",
				className: this.getControlClassName(this.state.updatingMaxDeleveragingYears),
				defaultValue: this.state.maxDeleveragingYears,
				disabled: this.isControlLoading(this.state.updatingMaxDeleveragingYears),
				label: "Nombre d’années de désendettement maximum",
				name: Names.maxDeleveragingYears
			},
			/** % maximum de remboursement de la dette sur CAF */
			{
				value: this.state.maxDebtRefund,
				addon: <FontAwesomeIcon icon="percent" />,
				className: this.getControlClassName(this.state.updatingMaxDebtRefund),
				defaultValue: this.state.maxDebtRefund,
				disabled: this.isControlLoading(this.state.updatingMaxDebtRefund),
				label: "% maximum de remboursement de la dette sur CAF",
				name: Names.maxDebtRefund
			}
		]

		let waiting = this.state.maxDebtRefund !== null || this.state.maxDeleveragingYears !== null || this.state.minGrossCashFlow !== null

		return (this.props.currentLocalAuthority && waiting ? (
		<div className="container-fluid section">
			<form
			className="column is-half-desktop">
				{controls.map((def, i) =>
				<div className="field" key={i}>
					<label className="label">{def.label}</label>
					<div className="field has-addons" style={{alignItems:'center'}}>
						<p className={def.className}>
							<input
							onChange={ e => this.valueOnChange(e) }
							className="input"
							defaultValue={def.defaultValue}
							disabled={def.disabled}
							name={def.name}
							type="number"
							onKeyDown={e => this.handleKeyDown(e)}
							onKeyPress={e => this.handleKeyPress(e)} />
						</p>
						<p className="control">
							<a className="button is-static">{def.addon}</a>
							<button className="button is-primary" type={"button"} onClick={(e)=>this.updateData(def)}>Mettre à jour</button>
						</p>
					</div>
				</div>)}
			</form>
			{/*ÉQUILIBRAGE DU SCÉNARIO DE FONCTIONNEMENT*/}
		        <Politique
				localAuthority={localAuthority}
				onClickScenariosId={(laID,sID,ppiID)=> this.callParticularScenario(laID,sID,ppiID)}
				handleSaveData={(data,id)=> this.saveScenarioData(data,id)}
				selectedScenarios={this.props.selectedScenarios}
				scenarios={this.props.allScenarios}
				loadingScenarios={this.props.loadingScenarios}
				loadingSlectedScenario={this.props.loadingSlectedScenario}
				loadingCurrentLocalAuthority={this.props.loadingCurrentLocalAuthority}
				loadingSavingScenaro={this.props.loadingSavingScenarioData}
				notify={(res)=>this.notifyAlert(res)}/>
		</div>) : (
      <div className="generate-loader">
        <Spinner fadeIn="none" name="wave" color="#3d3c3f" />
        <span>Chargement...</span>
      </div>)
		)}

	private setData = (localAuthority: LocalAuthority) => {
		this.setState({
			localshow:false,
			maxDebtRefund: localAuthority.maximumDebtRefund ? (localAuthority.maximumDebtRefund * 100).toString() : "",
			maxDeleveragingYears: localAuthority.maximumDeleveragingYears	? localAuthority.maximumDeleveragingYears.toString() : "",
			minGrossCashFlow: localAuthority.minimumGrossCashFlow	? localAuthority.minimumGrossCashFlow.toString() : ""
		})
	}

	private callParticularScenario(laID,sID,ppiID){
		let year = new Date().getFullYear()
		this.props.actions.changesOnSelected(laID,sID,ppiID,year)
	}

	private notifyAlert(res){
		this.props.actions.notify(
			NotificationLevel.Danger,
			"Impossible de charger les instructions",
			res
		)
	}

	private saveScenarioData(data,id){
		this.props.actions.saveScenarioData(data,id,this.props.currentLocalAuthority)
	}


	private getControlClassName(updating: boolean): string {
		return this.isControlLoading(updating)
		? "control is-expanded is-loading" : "control is-expanded"
	}

	private valueOnChange = (e) => {
		switch (e.target.name) {
			case Names.maxDeleveragingYears:
				this.setState({ maxDeleveragingYears : e.target.value})
				break
			case Names.minGrossCashFlow:
				this.setState({ minGrossCashFlow : e.target.value})
				break
			case Names.maxDebtRefund:
				this.setState({ maxDebtRefund : e.target.value})
				break
		}
  }

	private handleKeyDown(e: React.KeyboardEvent<Element>): void {
		const input = e.target as HTMLInputElement
		
		switch (e.key) {
			case "Escape":
				return this.resetValue(input)
			case "Tab":
				if (input.value === input.defaultValue) return
				return this.updateData(input)
		}
	}

	private handleKeyPress(e: React.KeyboardEvent<Element>): void {
		if ("Enter" !== e.key) return

		const input = e.target as HTMLInputElement
		this.updateData(input)
	}

	private isControlLoading(updating: boolean): boolean {
		return this.props.loadingCurrentLocalAuthority || updating
	}

	private resetValue(input: HTMLInputElement): void {
		switch (input.name) {
			case Names.maxDeleveragingYears:
				this.setState({ maxDeleveragingYears : this.props.currentLocalAuthority.maximumDeleveragingYears ? this.props.currentLocalAuthority.maximumDeleveragingYears.toString() : ""}, () => {
					input.value= this.state.maxDeleveragingYears
				});
				break
			case Names.minGrossCashFlow:
				this.setState({ minGrossCashFlow : this.props.currentLocalAuthority.maximumDeleveragingYears ? this.props.currentLocalAuthority.minimumGrossCashFlow.toString() : ""}, () => {
					input.value= this.state.minGrossCashFlow
				}); 
				
				break
			case Names.maxDebtRefund:
				this.setState({ maxDebtRefund : this.props.currentLocalAuthority.maximumDebtRefund ? (this.props.currentLocalAuthority.maximumDebtRefund * 100).toString() : ""}, () => {
					input.value= this.state.maxDebtRefund
				}); 
				break
		}
		
		input.blur()
	}
	
	private updateData(input: {name:string, defaultValue:string}): void {
		let parsedValue: number
		let rejectMessage: string
		let resolveMessage: string
		let serviceMethod: (la: LocalAuthority, value: number) => Promise<LocalAuthority>
		let updatingState: keyof State

		switch (input.name) {
			case Names.maxDebtRefund:
				updatingState = "updatingMaxDebtRefund"
				parsedValue = parseFloat(input.defaultValue) / 100
				rejectMessage = `Impossible de mettre à jour le pourcentage maximum de
				remboursement de la dette sur CAF.`
				resolveMessage = `Le pourcentage maximum de remboursement de la dette a
				bien été mis à jour.`
				serviceMethod = updateMaxDebtRefundPercentageOnCashFlow
				break
			case Names.maxDeleveragingYears:
				updatingState = "updatingMaxDeleveragingYears"
				parsedValue = parseInt(input.defaultValue)
				rejectMessage = `Impossible de mettre à jour le nombre d'années de
				désendettement maximum.`
				resolveMessage = `Le nombre d'années de désendettement maximum a bien
				été mis à jour.`
				serviceMethod = updateMaxDeleveragingYears
				break
			case Names.minGrossCashFlow:
				updatingState = "updatingMinGrossCashFlow"
				parsedValue = parseFloat(input.defaultValue)
				rejectMessage = `Impossible de mettre à jour la CAF brute minimum.`
				resolveMessage = `La CAF brute minimum a bien été mise à jour.`
				serviceMethod = updateMinGrossCashFlow
				break
			default: return
		}

		this.setState({ [updatingState]: true} as Pick<State, keyof State>, () => {
			serviceMethod(this.props.currentLocalAuthority, parsedValue)
			.then(la => {
				this.setState(
					{ [updatingState]: false} as Pick<State, keyof State>,
					() => {
						this.props.actions.updateCurrentLocalAuthority(la)
						this.props.actions.notify(NotificationLevel.Success, resolveMessage, undefined)
					})
			})
			.catch((reason: Error) => {
				this.setState(
					{ [updatingState]: false} as Pick<State, keyof State>,
					() => {
						this.props.actions.notify(NotificationLevel.Danger, rejectMessage, reason)
					})
			})
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(Policy)

export interface Props {}

interface ControlDefinition {
	addon: React.ReactNode
	className: string
	defaultValue: string
	disabled: boolean
	label: string
	name: string
	value:string
}

interface Params {}

interface State {
	updatingMaxDebtRefund: boolean
	updatingMaxDeleveragingYears: boolean
	updatingMinGrossCashFlow: boolean
	localshow:boolean
	maxDebtRefund: any,
	maxDeleveragingYears: any,
	minGrossCashFlow: any
}

type InjectedProps = MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<Params>


// WEBPACK FOOTER //
// ./src/component/policy/index.tsx